import { createSlice } from '@reduxjs/toolkit';
import { getWeatherZones } from './itemCreationWizardApi';
import mappedItemTypes from 'services/items/mappedItemTypes';

const initialState = {
    itemTypes: [],
    genericAssetTemplates: [],
    selectedItemTypeId: 0,
    selectedItemTypeName: '',
    selectedAutoForm: '',
    selectedBookId: 0,
    createdItemId: 0,
    steps: {
        itemFormStep: 'itemFormStep',
        subItemMethodDecisionStep: 'subItemMethodDecisionStep',
        subItemGenericAssetStep: 'subItemGenericAssetStep',
        subItemCustomStep: 'subItemCustomStep',
        basisSetupStep: 'basisSetupStep',
        subItemBatteryCustomStep: 'subItemBatteryCustomStep',
        subItemRenewablesCustomStep: 'subItemRenewablesCustomStep',
        moveToItemPageStep: 'moveToItemPageStep',
    },
    itemFormData: {
        itemId: '',
        itemTypeId: '',
        description: '',
        bookId: '',
        pricingPointId: '',
        rtelecBasisPriceId: '',
        latitude: '',
        longitude: '',
        gasBasisId: '',
        cO2BasisId: '',
    },
    currentStep: 'itemFormStep',
    hasGenericAssetTimedOut: false,
    weatherZones: [],
    itemTypesWithWeatherZones: [mappedItemTypes.WIND_ASSET.id, mappedItemTypes.SOLAR_ASSET.id],
    renewableProjectDates: [
        {
            subItemId: 0,
            enteredOnlineDate: '',
            enteredOfflineDate: '',
        },
    ],
};

const itemCreationWizardSlice = createSlice({
    name: 'itemCreationWizard',
    initialState,
    reducers: {
        setSelectedBookId: (state, action) => {
            state.selectedBookId = action.payload;
        },
        setSelectedItemTypeId: (state, action) => {
            state.selectedItemTypeId = action.payload;
        },
        setSelectedItemTypeName: (state, action) => {
            state.selectedItemTypeName = action.payload;
        },
        setSelectedAutoForm: (state, action) => {
            state.selectedAutoForm = action.payload;
        },
        setCreatedItemId: (state, action) => {
            state.createdItemId = action.payload;
        },
        setItemFormData: (state, action) => {
            state.itemFormData = action.payload;
        },
        setGenericAssetTemplates: (state, action) => {
            state.genericAssetTemplates = action.payload;
        },
        setHasGenericAssetTimedOut: (state, action) => {
            state.hasGenericAssetTimedOut = action.payload;
        },
        addRenewableProjectDate: (state, action) => {
            const existingIndex = state.renewableProjectDates.findIndex(
                (projectDate) => projectDate.subItemId === action.payload.subItemId
            );

            if (existingIndex === -1) {
                state.renewableProjectDates.push({
                    subItemId: action.payload.subItemId,
                    enteredOnlineDate: action.payload.enteredOnlineDate ?? '',
                    enteredOfflineDate: action.payload.enteredOfflineDate ?? '',
                });
            }
        },
        removeRenewableProjectDate: (state, action) => {
            state.renewableProjectDates = state.renewableProjectDates.filter(
                (projectDate) => projectDate.subItemId !== action.payload
            );
        },
        changeCurrentStep: (state, action) => {
            state.currentStep = action.payload;
        },
        reset: (state, action) => {
            state.selectedItemTypeId = initialState.selectedItemTypeId;
            state.selectedBookId = initialState.selectedBookId;
            state.createdItemId = initialState.createdItemId;
            state.selectedAutoForm = initialState.selectedAutoForm;
            state.currentStep = initialState.currentStep;
            state.genericAssetTemplates = initialState.genericAssetTemplates;
            state.selectedItemTypeName = initialState.selectedItemTypeName;
            state.itemFormData = initialState.itemFormData;
            state.hasGenericAssetTimedOut = initialState.hasGenericAssetTimedOut;
            state.weatherZones = initialState.weatherZones;
            state.renewableProjectDates = initialState.renewableProjectDates;
        },
    },
    extraReducers: {
        [getWeatherZones.fulfilled]: (state, action) => {
            state.weatherZones = action.payload;
        },
    },
});

export const {
    setSelectedBookId,
    setSelectedItemTypeId,
    setSelectedItemTypeName,
    setCreatedItemId,
    changeCurrentStep,
    setSelectedAutoForm,
    setGenericAssetTemplates,
    setHasGenericAssetTimedOut,
    setItemFormData,
    addRenewableProjectDate,
    removeRenewableProjectDate,
    reset,
} = itemCreationWizardSlice.actions;
export default itemCreationWizardSlice.reducer;
